import { Subject, Subscription } from "rxjs";
import Task from "./task";

/**
 * This class is responsible for all `Task`'s within
 * the library.
 * 
 * @author Stan Hurks
 */
export default class Tasks {

    /**
     * All the tasks
     */
    private static readonly tasks: {[id: number]: Task<any>} = {}

    /**
     * All the subscriptions for the tasks
     */
    private static readonly subscriptions: {[id: number]: Subscription} = {}

    /**
     * The amount of tasks initialized
     */
    private static counter: number = 0

    /**
     * Initialize a task.
     * 
     * @param task The task
     * @returns The task id
     */
    public static initializeTask = (task: Task<any>): number => {
        console.debug(`Initializing task "${task.name}"...`)
        
        this.tasks[++Tasks.counter] = task

        this.subscriptions[Tasks.counter] = task.subject.subscribe((data) => {
            if (task.shouldExecute(data)) {
                console.debug(`Running task "${task.name}"...`)

                task.execute(data)
            }
        })
        
        return Tasks.counter
    }

    /**
     * Stops a task.
     * 
     * @param taskId The task id
     */
    public static stopTask = (taskId: number) => {
        const task = Tasks.tasks[taskId]
        const subscription = Tasks.subscriptions[taskId]
        
        if (!task || !subscription) {
            console.error(`Could not find task with id: ${taskId}.`)
            
            return
        }

        // Unsubscribe
        subscription.unsubscribe()

        // Delete the task
        delete Tasks.tasks[taskId]
        delete Tasks.subscriptions[taskId]
    }
}